import angular from 'angular';
import contactComponent from './contact.component';
import emailService from '../../Services/email.service';
import constants from '../../Constants/constants.module';
export default angular.module('app.contact', [constants])
    .service('emailService', emailService)
    .component('contactComponent', contactComponent)
    .name;
